 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		56: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		56: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"23":"affiliate-page","24":"algolia-search","25":"algolia-search-local","26":"card-error","27":"cart-drawer","28":"christmas-holiday-gift-cards-page","29":"consumer-checkout-page-footer-content","30":"create-a-card-carrier","31":"create-a-card-landing","32":"create-a-card-review","33":"designer-gift-cards","34":"diwali-holiday-gift-cards-page","35":"fiserv-consumer-checkout-page","36":"gift-card-app-page","37":"gift-card-balance-check-page","38":"gift-card-occasions","39":"greeting-card-landing-page","40":"handwritten-page","41":"hanukkah-holiday-gift-cards-page","42":"home-page","43":"kwanzaa-holiday-gift-cards-page","44":"legit-page","46":"mastercard-pla-landing-page","47":"newsletter-signup-page","48":"open-loop-activate-check-balance","49":"open-loop-virtual-exchange","50":"order-details","51":"order-status","52":"pla-landing-page-container","53":"redeem-gift","54":"redeem-gyp-gift","55":"reviews-page","57":"smb-apply","58":"smb-cobrand-cards","59":"smb-order-details","60":"smb-order-details-pdf-invoice","61":"smb-order-flow","62":"smb-order-flow-cancelled","63":"smb-order-flow-confirmation","64":"smb-order-flow-customize-product","65":"smb-order-flow-footer-content","66":"smb-order-flow-landing","67":"smb-order-flow-login","68":"smb-order-flow-merchant","69":"smb-order-flow-merchant-directory","70":"smb-order-flow-place-order","71":"smb-order-flow-product-details","72":"smb-order-flow-registration","73":"smb-resubmission-portal","74":"store-review-list-portal","75":"update-failed-email-recipient","76":"update-payment-method","77":"visa-pla-landing-page"}[chunkId]||chunkId) + "." + {"0":"a1e40206","1":"b0f6f63a","2":"efaae2f0","3":"45468f81","4":"f4ab542f","5":"ed6f2826","6":"79bdd9f3","7":"01e8b53e","8":"3d4f61ea","9":"460dd0d0","10":"a137769f","11":"85a84860","12":"d6bc27f7","13":"a5bcdae1","14":"f0af412f","15":"6e6c6471","16":"d4916fca","17":"286ca06a","18":"9f76f74a","19":"868f38a2","20":"2111ab21","21":"5d28cfe7","22":"56b768fb","23":"02b1c72e","24":"53e8eb22","25":"33d044ae","26":"73f62662","27":"ec1ccf71","28":"9fe0688f","29":"e8636cea","30":"fc6b650e","31":"0c702d4d","32":"24b5c608","33":"4e4796d6","34":"74f02d0f","35":"cbf695a7","36":"18a8c48d","37":"08bb69bf","38":"bb4ebe90","39":"ed49753e","40":"ff3ee533","41":"42f6b2aa","42":"ecd086a1","43":"6fffc75c","44":"2a17e8cd","46":"7323bce8","47":"2a7a76ed","48":"144f1739","49":"d8af19f3","50":"4ec9563a","51":"e4ab24e7","52":"9b4b41c7","53":"4962415f","54":"2041d32a","55":"e421431b","57":"074e482f","58":"de156129","59":"fbd93ced","60":"f748a7e9","61":"b72ef7b8","62":"da377f98","63":"cda29fcb","64":"4131a2ff","65":"c80da9ce","66":"c75e51d4","67":"cca9aad0","68":"6070d64c","69":"3a174240","70":"c934152c","71":"069eebb5","72":"2e687f8d","73":"b85a5c90","74":"5dbd4892","75":"d56c4826","76":"2144d12e","77":"b41caada","79":"906fb05b","80":"19e9e9b3","81":"8f6e1757","82":"d7805bd5","83":"b118806a","84":"2fb8c119","85":"5e745447","86":"3683cc28","87":"b376d3cd","88":"b37bd366","89":"362b230d","90":"cd0bff5f","91":"631037fb"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"31":1,"51":1,"64":1,"83":1,"86":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"23":"affiliate-page","24":"algolia-search","25":"algolia-search-local","26":"card-error","27":"cart-drawer","28":"christmas-holiday-gift-cards-page","29":"consumer-checkout-page-footer-content","30":"create-a-card-carrier","31":"create-a-card-landing","32":"create-a-card-review","33":"designer-gift-cards","34":"diwali-holiday-gift-cards-page","35":"fiserv-consumer-checkout-page","36":"gift-card-app-page","37":"gift-card-balance-check-page","38":"gift-card-occasions","39":"greeting-card-landing-page","40":"handwritten-page","41":"hanukkah-holiday-gift-cards-page","42":"home-page","43":"kwanzaa-holiday-gift-cards-page","44":"legit-page","46":"mastercard-pla-landing-page","47":"newsletter-signup-page","48":"open-loop-activate-check-balance","49":"open-loop-virtual-exchange","50":"order-details","51":"order-status","52":"pla-landing-page-container","53":"redeem-gift","54":"redeem-gyp-gift","55":"reviews-page","57":"smb-apply","58":"smb-cobrand-cards","59":"smb-order-details","60":"smb-order-details-pdf-invoice","61":"smb-order-flow","62":"smb-order-flow-cancelled","63":"smb-order-flow-confirmation","64":"smb-order-flow-customize-product","65":"smb-order-flow-footer-content","66":"smb-order-flow-landing","67":"smb-order-flow-login","68":"smb-order-flow-merchant","69":"smb-order-flow-merchant-directory","70":"smb-order-flow-place-order","71":"smb-order-flow-product-details","72":"smb-order-flow-registration","73":"smb-resubmission-portal","74":"store-review-list-portal","75":"update-failed-email-recipient","76":"update-payment-method","77":"visa-pla-landing-page"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"31d6cfe0","20":"31d6cfe0","21":"31d6cfe0","22":"31d6cfe0","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"7176885d","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","50":"31d6cfe0","51":"21f59128","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"c8c378cd","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"31d6cfe0","71":"31d6cfe0","72":"31d6cfe0","73":"31d6cfe0","74":"31d6cfe0","75":"31d6cfe0","76":"31d6cfe0","77":"31d6cfe0","79":"31d6cfe0","80":"31d6cfe0","81":"31d6cfe0","82":"31d6cfe0","83":"bef3f8af","84":"31d6cfe0","85":"31d6cfe0","86":"c8c378cd","87":"31d6cfe0","88":"31d6cfe0","89":"31d6cfe0","90":"31d6cfe0","91":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://sitecdn.giftcardgranny.com/19594/react/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpgift-card-granny-react"] = this["webpackJsonpgift-card-granny-react"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
